<template>
  <div class="weekly-calendar">
    <div class="switch-date-bar">
      <div class="date-tool">
        <i class="icon-chevron-back" />
        <p>2020.05</p>
        <i class="icon-chevron-forward" />
      </div>
      <WsButton001>
        今天
      </WsButton001>
    </div>
    <div class="calendar-table">
      <div class="column-header">
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
        <div class="column-header-item">
          日
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>27</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>28</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>29</p>
          </div>
        </div>
        <div class="row-item today">
          <div class="date">
            <p>30</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>1</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>2</p>
          </div>
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>3</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>4</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>5</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>6</p>
          </div>
        </div>
        <div class="row-item today">
          <div class="date">
            <p>7</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>8</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>9</p>
          </div>
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
      </div>
      <div class="calendar-table-row">
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
        <div class="row-item">
          <div class="date">
            <p>26</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "WeeklyCalendar",
};
</script>
<style lang="scss" scoped>
.weekly-calendar {
  width: 100%;
  .switch-date-bar {
    @include flex_align;
    justify-content: center;
    position: relative;
    height: 36px;
    .date-tool {
      @include flex;
      color: var(--blue-500);
      p {
        @include auto_margin_left(20px);
        font-size: 1.125rem;
        font-weight: bold;
        line-height: 1.33;
      }
      i {
        @include auto_margin_left(20px);
        font-size: 24px;
        cursor: pointer;
      }
    }
    .gradient-button {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 36px;
      &::before {
        width: 100px;
        height: 36px;
      }
    }
  }
  .calendar-table {
    @include auto_margin_top(8px);
    .column-header {
      @include flex;
      justify-content: space-between;
      .column-header-item {
        width: calc((100% - 12px) / 7);
        font-size: 1rem;
        line-height: 1.38;
        letter-spacing: 1px;
        text-align: right;
        color: var(--gray-700);
      }
    }
    .calendar-table-row {
      @include auto_margin_top(2px);
      @include flex;
      justify-content: space-between;
      .row-item {
        width: calc((100% - 12px) / 7);
        height: 132px;
        font-size: 1rem;
        line-height: 1.38;
        letter-spacing: 1px;
        text-align: right;
        border-radius: 5px;
        color: var(--gray-700);
        background-color: rgba($color: #52a8e8, $alpha: 0.2);
        .date {
          @include flex_align;
          justify-content: flex-end;
          padding: 5px 11px;
          p {
            align-self: flex-end;
          }
        }
        &.today {
          position: relative;
          p {
            padding: 1px 7px;
            color: var(--white);
            border-radius: 12px;
            background-color: var(--blue-500);
          }
        }
      }
    }
  }
}
</style>